import React, { useState } from "react";
import "./ContactUs.css";
import AudioRecorderModal from "./AudioRecorderModal";
import TextMessageModal from "./TextMessageModal";
import { useRecorderModal } from "../contextApi/RecorderModalContext";

const ContactUs = () => {
  const [isHovered, setIsHovered] = useState(false);
  const [hoverTimeout, setHoverTimeout] = useState(null);
  const { openAudioModal, openTextModal, showRecorderModal, closeAudioModal, showTextModal, closeTextModal } = useRecorderModal();
  const handleMouseEnter = () => {
    const timeout = setTimeout(() => {
      setIsHovered(true);
    }, 300); // 300ms delay like in Figma

    setHoverTimeout(timeout);
  };

  const handleMouseLeave = () => {
    clearTimeout(hoverTimeout);
    setIsHovered(false);
  };
  const handleMicIconClick = () => {
    closeTextModal()
    openAudioModal()
  }
  const handleChatIconClick = () => {
    closeAudioModal()
    openTextModal()
  }
  const onClose = () =>{
    closeAudioModal()
  }
  const onClose1 = (e) =>{
    // if (e.target.classList.contains('modal-overlay')) {
    //   setShowTextModel(false);
    // }
    if (e.target.className.includes('modal-overlay') || e.target.className.includes('cancel')) {
      // setShowTextModel(false);
      closeTextModal()
    }
  }

    // Basic mobile detection
  const isMobile = /Mobi|Android|iPhone/i.test(navigator.userAgent);

  const email = 'hello@louievoice.com';

  const mobileLink = `mailto:${email}`;
  const desktopLink = `https://mail.google.com/mail/?view=cm&fs=1&to=${email}`;

  return (
    <>
    <div
      className={`contact-container ${isHovered ? "expanded" : ""}`}
      // onMouseEnter={() => setIsHovered(true)}
      // onMouseLeave={() => setIsHovered(false)}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      {!isHovered ? (
        <div className="contact-tab">Contact Us</div>
      ) : (
        <div className="contact-expanded">
          <div className="contact-tab contact-tab1">Contact Us</div>
          <div className="contact-icons">
            <a href="https://www.linkedin.com/in/pramit-bhargava-1860668/" target="_blank" rel="noopener noreferrer">
              <img src="/images/linkedin_icon.png"  alt="LinkedIn"/>
            </a>
            {/* <a href="mailto:hello@louievoice.com">
              <img src="/images/email_icon.png"  alt="Email"/>
            </a> */}
            <a
              href={isMobile ? mobileLink : desktopLink}
              target={isMobile ? '_self' : '_blank'}
              rel="noopener noreferrer"
            >
              <img src="/images/email_icon.png" alt="Email" />
            </a>

            <img className="mic-icon" src="/images/mic_icon.png" alt="" onClick={handleMicIconClick} />
            <img src="/images/chat_icon.png" alt="" onClick={handleChatIconClick} />
          </div>
        </div>
      )}
    </div>
    { showRecorderModal ? (
        <AudioRecorderModal onClose={onClose}  />
      ) :
        ""      
      }
    { showTextModal ? (
        <TextMessageModal onClose={onClose1}/>
      ) :
        ""      
      }
    </>
  );
};

export default ContactUs;
